import { ORDER_METHOD, OrderMethod } from '@/domain/models/Order/orderMethod';

export const PAY_TYPE = {
  CREDIT_CARD: 'CREDIT_CARD',
  APPLE_PAY: 'APPLE_PAY',
  IN_STORE_PAYMENT: 'IN_STORE_PAYMENT',
  CASH: 'CASH',
  PAYPAY: 'PayPay',
  D_PAY: 'D_PAY',
  RAKUTEN_PAY: 'RAKUTEN_PAY',
  AU_PAY: 'AU_PAY',
  AMAZON_PAY: 'AMAZON_PAY',
  MERPAY: 'MERPAY',
  ON_DELIVERY: 'ON_DELIVERY',
} as const;

export const payType = {
  [PAY_TYPE.CREDIT_CARD]: 'クレジットカード決済',
  [PAY_TYPE.APPLE_PAY]: 'Apple Pay',
  [PAY_TYPE.IN_STORE_PAYMENT]: '店頭支払い',
  [PAY_TYPE.ON_DELIVERY]: 'お受け取り時決済',
  [PAY_TYPE.CASH]: '現金',
  [PAY_TYPE.PAYPAY]: 'PayPay',
  [PAY_TYPE.D_PAY]: 'd払い',
  [PAY_TYPE.RAKUTEN_PAY]: '楽天ペイ',
  [PAY_TYPE.AU_PAY]: 'au PAY',
  [PAY_TYPE.AMAZON_PAY]: 'Amazon Pay',
  [PAY_TYPE.MERPAY]: 'メルペイ',
  '': '',
} as const;

export type PayType = keyof typeof payType;

export type SitePayTypeSettingKey =
  | 'TAKE_OUT'
  | 'EAT_IN'
  | 'DELIVERY_UBER'
  | 'DELIVERY_IN_HOUSE';

export type SitePayTypeSetting = {
  setting_key: SitePayTypeSettingKey;
  pay_types: PayType[];
};

export function SitePayTypeSettingKeyToOrderMethod(
  key: SitePayTypeSettingKey
): OrderMethod {
  if (key === 'TAKE_OUT') {
    return ORDER_METHOD.TAKE_OUT;
  }
  if (key === 'EAT_IN') {
    return ORDER_METHOD.EAT_IN;
  }
  if (key === 'DELIVERY_UBER') {
    return ORDER_METHOD.DELIVERY;
  }
  if (key === 'DELIVERY_IN_HOUSE') {
    return ORDER_METHOD.DELIVERY;
  }
  return ORDER_METHOD.TAKE_OUT;
}

export function existsInPayTypeSettings(
  payTypeSettings: SitePayTypeSetting[],
  targetKey: SitePayTypeSettingKey,
  targetPayType: PayType
): boolean {
  return payTypeSettings.some(
    (payTypeSetting) =>
      payTypeSetting.setting_key === targetKey &&
      payTypeSetting.pay_types.some((payType) => payType === targetPayType)
  );
}

export function existsByPayType(
  payTypeSettings: SitePayTypeSetting[],
  targetPayType: PayType
): boolean {
  return payTypeSettings.some((payTypeSetting) =>
    payTypeSetting.pay_types.some((payType) => payType === targetPayType)
  );
}

export function existsBySettingKey(
  payTypeSettings: SitePayTypeSetting[],
  targetKey: SitePayTypeSettingKey
): boolean {
  return payTypeSettings.some(
    (payTypeSetting) =>
      payTypeSetting.setting_key === targetKey &&
      payTypeSetting.pay_types.length > 0
  );
}

const GmoSettingRequiredPayTypes: PayType[] = [
  PAY_TYPE.CREDIT_CARD,
  PAY_TYPE.APPLE_PAY,
  PAY_TYPE.PAYPAY,
  PAY_TYPE.D_PAY,
  PAY_TYPE.RAKUTEN_PAY,
  PAY_TYPE.AU_PAY,
  PAY_TYPE.AMAZON_PAY,
  PAY_TYPE.MERPAY,
];

export function gmoSettingRequired(payType: PayType): boolean {
  return GmoSettingRequiredPayTypes.includes(payType);
}

export function gmoShopInformationRequired(
  payTypeSettings: SitePayTypeSetting[]
): boolean {
  return (
    existsByPayType(payTypeSettings, PAY_TYPE.CREDIT_CARD) ||
    existsByPayType(payTypeSettings, PAY_TYPE.APPLE_PAY)
  );
}

export function threeDSecureSettingRequired(
  payTypeSettings: SitePayTypeSetting[]
): boolean {
  return existsByPayType(payTypeSettings, PAY_TYPE.CREDIT_CARD);
}

export function payTypeTitle(orderMethod: OrderMethod): string {
  if (orderMethod === ORDER_METHOD.TAKE_OUT) {
    return '対応決済手段（テイクアウト）';
  }
  if (orderMethod === ORDER_METHOD.EAT_IN) {
    return '対応決済手段（店内飲食）';
  }
  if (orderMethod === ORDER_METHOD.DELIVERY) {
    return '対応決済手段（デリバリー）';
  }
  return '';
}

export function sitePayTypeSettingKeyTitle(
  payTypeSettingKey: SitePayTypeSettingKey
): string {
  if (payTypeSettingKey === 'DELIVERY_UBER') {
    return 'Uber Direct';
  }
  if (payTypeSettingKey === 'DELIVERY_IN_HOUSE') {
    return '自社配達';
  }

  return '';
}
